import { render, staticRenderFns } from "./CalendarDisplay.vue?vue&type=template&id=2c089206&scoped=true"
import script from "./CalendarDisplay.vue?vue&type=script&lang=js"
export * from "./CalendarDisplay.vue?vue&type=script&lang=js"
import style0 from "./CalendarDisplay.vue?vue&type=style&index=0&id=2c089206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c089206",
  null
  
)

export default component.exports